import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    applicationEditProcesses: []
}

const statuForwardSlice = createSlice({
    name: 'statuForward',
    initialState,
    reducers: {
        addAppcliationEditProcess(state, action) {
            if(!state.applicationEditProcesses) state.applicationEditProcesses = []
            let {key ,activty }= action.payload
            state.applicationEditProcesses.push(activty)
        
        },
        deleteApplicationEditProcess(state, action) {
            let {key ,activty }= action.payload
            if (state.applicationEditProcesses.length == 1) {
                state.applicationEditProcesses.pop()
            } else if (state.applicationEditProcesses.length == 0) {
            } else {

                let processFinding = state.applicationEditProcesses.find((element) => element == activty)
                const indexRmoeveProcess = state.applicationEditProcesses.indexOf(processFinding, 0)
                state.applicationEditProcesses.splice(indexRmoeveProcess, 1)
            }

        },
        clearApplicationEditProcess(state){
            state.applicationEditProcesses= []
        }
    }
});

export const {
    addAppcliationEditProcess,
    deleteApplicationEditProcess,
    clearApplicationEditProcess
} = statuForwardSlice.actions;

export default statuForwardSlice.reducer;




